export default "__VITE_ASSET__D4F_kaA1__"